<div class="div-title">
  <h1 mat-dialog-title>
    {{ data.title }}
  </h1>
</div>
<div class="fields" mat-dialog-content>
  <table mat-table [dataSource]="data.controleFinancaMovimentos" class="data-table mat-elevation-z8" matSort
    matSortActive="dtMovimentacao">

    <ng-container matColumnDef="blSelecionado">
      <th mat-header-cell *matHeaderCellDef class="bl-selecionado-column">
        <mat-checkbox class="custom-checkbox" (change)="toggleAllSelection($event)" [checked]="isAllSelected()"
          [indeterminate]="isIndeterminate()" color="primary">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let controleFinancaMovimentos" class="bl-selecionado-column">
        <mat-checkbox class="custom-checkbox" [(ngModel)]="controleFinancaMovimentos.blSelecionado"
          (change)="onSelectionChange()" color="primary">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="noMovimentacao">
      <th mat-header-cell *matHeaderCellDef class="no-movimentacao-column"> Descrição </th>
      <td mat-cell *matCellDef="let controleFinancaMovimentos" class="no-movimentacao-column">
        <mat-form-field class="field-column">
          <input type="text" matInput minlength="3" maxlength="100"
            [id]="'input-noMovimentacao-' + controleFinancaMovimentos.id"
            [(ngModel)]="controleFinancaMovimentos.noMovimentacao" />
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="vlMovimentacao">
      <th mat-header-cell *matHeaderCellDef class="vl-movimentacao-column"> Valor </th>
      <td mat-cell *matCellDef="let controleFinancaMovimentos" class="vl-movimentacao-column">
        <mat-form-field>
          <input type="number" matInput [(ngModel)]="controleFinancaMovimentos.vlMovimentacao" />
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="dtMovimentacao">
      <th mat-header-cell *matHeaderCellDef class="dt-movimentacao-column"> Data </th>
      <td mat-cell *matCellDef="let controleFinancaMovimentos" class="dt-movimentacao-column">
        <mat-form-field>
          <input matInput [matDatepicker]="dtMovimentacao" [(ngModel)]="controleFinancaMovimentos.dtMovimentacao">
          <mat-datepicker-toggle matSuffix [for]="dtMovimentacao" tabindex="-1"></mat-datepicker-toggle>
          <mat-datepicker #dtMovimentacao></mat-datepicker>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="dtVencimento">
      <th mat-header-cell *matHeaderCellDef class="dt-vencimento-column"> Vcto. </th>
      <td mat-cell *matCellDef="let controleFinancaMovimentos" class="dt-vencimento-column">
        <mat-form-field>
          <input matInput [matDatepicker]="dtVencimento" [(ngModel)]="controleFinancaMovimentos.dtVencimento">
          <mat-datepicker-toggle matSuffix [for]="dtVencimento" tabindex="-1"></mat-datepicker-toggle>
          <mat-datepicker #dtVencimento></mat-datepicker>
        </mat-form-field>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<div class="div-buttons" mat-dialog-actions>
  <button class="btn" mat-raised-button color="primary" [disabled]="!hasSelectedMovimentos()"
    (click)="confirmSelection()">
    {{ data.buttonText }}
  </button>
  <button class="btn" mat-button (click)="cancelDialog()">
    {{ data.cancelButtonText }}
  </button>
</div>